module.exports = __webpack_public_path__ + "static/media/8OLA19.4c7e1b3d.jpg";